module.exports = __webpack_public_path__ + "fonts/highs-and-lows-icon.svg";